<div class="grid grid-cols-12 w-full">
    @for (month of [1,2,3,4,5,6,7,8,9,10,11,12]; track month) {
    <div class="w-full" [ngClass]="{
            'pr-[1px]': isLastPeriod(month)
        }">
        <div class="col-span-1 h-2 w-full" [ngClass]="{
                'rounded-l-lg': isFirstPeriod(month), 
                'rounded-r-lg': isLastPeriod(month)
            }" [style.backgroundColor]="isInPeriod(month) ? COLORS.PERIODS[type] : 'transparent'">
        </div>
    </div>
    }
</div>